import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-life-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_459_2122)">
        <path
          d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
          stroke="#334155"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 12.75H6.75L9.01 7.09996C9.06689 6.95911 9.16527 6.83888 9.29207 6.75524C9.41888 6.67159 9.56812 6.62848 9.72 6.63163C9.87188 6.63478 10.0192 6.68403 10.1424 6.77285C10.2657 6.86168 10.359 6.98587 10.41 7.12896L13.702 16.454C13.7498 16.5894 13.8355 16.7082 13.9489 16.7963C14.0622 16.8845 14.1985 16.9382 14.3415 16.9511C14.4845 16.9641 14.6283 16.9357 14.7556 16.8694C14.883 16.8031 14.9886 16.7016 15.06 16.577L17.25 12.75H20.25"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_459_2122">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class LifeInsuranceIconComponent extends BaseIconComponent {}
